import { Flex, Loader, Text } from "@mantine/core";

import { useContext } from "react";
import { useGetEvent } from "../../../../api/event";
import { getCurrentWorkspace } from "../../../../services/userConfig";
import { AuthContext } from "../../../../services/context";
import EventDates from "../EventDates";
import General from "./General";
import EventVisibility from "../EventVisibility";

export default function GeneralTab() {
  const { user } = useContext(AuthContext);
  const currentWorkspace = getCurrentWorkspace(user);

  const isSysAdmin = user?.role === "sysAdmin";

  const { data, isPending, isError, error } = useGetEvent(
    currentWorkspace?.eventId
  );

  if (isPending) {
    return <Loader mt={10} />;
  }
  if (isError) {
    return <Text c="red">{error.message}</Text>;
  }
  return (
    <Flex gap="md" wrap="wrap">
      <General data={data} isSysAdmin={isSysAdmin} />
      <Flex direction="column" flex="1">
        <EventVisibility event={data} />
        <EventDates event={data} />
      </Flex>
    </Flex>
  );
}
